<script>
import boxService from "@/services/box";
import InputTag from "@/components/ui/InputTag";

export default {
  name: "ModalBox",

  components: {
    InputTag,
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    institutionId: {
      type: String,
      required: true,
    },
    currentBox: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      box: {
        name: "",
        screenIds: [],
      },
      isSaving: false,
    };
  },

  computed: {
    isUpdate() {
      return !!this.currentBox?._id;
    },
    title() {
      return this.isUpdate ? "Editar box" : "Nuevo box";
    },
    canSave() {
      return !!this.box.name?.trim();
    },
  },

  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) this.reset();
      },
    },
  },

  methods: {
    reset() {
      if (this.isUpdate) {
        this.box = {
          name: this.currentBox.name || "",
          screenIds: [...(this.currentBox.screenIds || [])],
        };
      } else {
        this.box = { name: "", screenIds: [] };
      }
    },

    close() {
      this.$emit("close");
    },

    async submit() {
      if (!this.canSave) return;

      if (this.$refs.screenIdsInput?.newTag?.trim()) {
        this.$refs.screenIdsInput.handleKeyUp();
        await this.$nextTick();
      }

      this.isSaving = true;
      try {
        const payload = {
          name: this.box.name.trim(),
          screenIds: this.box.screenIds,
        };
        let saved;
        if (this.isUpdate) {
          saved = await boxService.updateBox(this.currentBox._id, payload);
        } else {
          saved = await boxService.createBox({
            ...payload,
            institution: this.institutionId,
          });
        }
        this.$emit("saved", { box: saved, isUpdate: this.isUpdate });
        this.close();
      } catch (e) {
        console.error("Error saving box", e);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<template lang="pug">
  el-dialog(
    :title="title"
    :visible="visible"
    width="480px"
    :close-on-click-modal="false"
    :append-to-body="true"
    @close="close"
  )
    .box-form
      fieldset.box-form__field
        label.label * Nombre
        el-input(v-model="box.name" placeholder="Nombre del box" autofocus)
      fieldset.box-form__field
        label.label Pantallas (screen IDs)
        input-tag(
          ref="screenIdsInput"
          v-model="box.screenIds"
          placeholder="Escribir un ID y presionar Enter"
        )
        span.box-form__hint Estos IDs se enviarán al proveedor de pantallas cuando se llame a un paciente desde este box.
    span.dialog-footer(slot="footer")
      el-button(@click="close") Cancelar
      el-button(
        type="primary"
        :loading="isSaving"
        :disabled="!canSave"
        @click="submit"
      ) Guardar
</template>

<style lang="scss" scoped>
.box-form {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__field {
    border: none;
    padding: 0;
    margin: 0;

    .label {
      display: block;
      margin-bottom: 6px;
      font-size: 13px;
      color: #303133;
      font-weight: 500;
    }
  }

  &__hint {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: #909399;
  }
}
</style>
